import React from "react";

export default function TwProgressBar(props) {
  const { children, className = "", error = false, value, color = "bg-blue-600", max = 100} = props
  const percentage = Math.min((value / max) * 100, 100);
  
  return (
    <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
      <div
        className={`${color} h-full transition-all duration-300 rounded-full`}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
}
